export default "__VITE_ASSET__8QWgR9vB__"